export const STAT_MOD_MIN = -99;
export const STAT_MOD_MAX = 99;
export const PROF_BONUS_MIN = 0;
export const PROF_BONUS_MAX = 99;
export const OTHER_CONSTANT_MIN = -99;
export const OTHER_CONSTANT_MAX = 99;
